import React, { useEffect } from 'react';

const Product2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const images = [
    "/nova1.jpg",
    "/nova2.jpg",
    "/nova3.jpg",
    "/nova4.jpg",
    "/nova5.png",
  ];

  return (
    <div className="p-10 bg-black text-white">
      <div className="space-y-12">

        {/* Company Overview Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src={images[0]}
              alt="Company Overview"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-white">
              Novacam Technologies Inc.
            </h1>

            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Company Overview
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Novacam Technologies Inc. specializes in high-precision, non-contact optical metrology and interferometry systems. 
              Their fiber-based solutions allow measurement of surfaces, thickness, and internal geometries with nanometer-level accuracy, 
              catering to industries like aerospace, automotive, electronics, and scientific research.
            </p>
          </div>
        </section>

        {/* Application Industries Section */}
        <section className="text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Industries We Serve
          </h3>
          <ul className="list-disc list-inside text-lg space-y-4 transition-all duration-300 hover:text-gray-300">
            <li><strong>Aerospace & Defense:</strong> Precision measurement and inspection of components</li>
            <li><strong>Automotive:</strong> Non-contact metrology for parts and assemblies</li>
            <li><strong>Semiconductors & Electronics:</strong> Surface, layer, and thickness inspection</li>
            <li><strong>Biomedical & Life Sciences:</strong> High-resolution optical profiling</li>
            <li><strong>Advanced Materials:</strong> Measurement of thin films, coatings, and composites</li>
            <li><strong>Research & Labs:</strong> Scientific measurement and prototyping</li>
          </ul>
        </section>

        {/* Product / Technology Section */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src={images[1]}
              alt="Products & Technology"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Our Technology
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Novacam's systems utilize optical low-coherence interferometry to provide non-contact 3D surface and thickness measurements. 
              Their fiber-based probes allow inspection of hard-to-reach areas, while ensuring high speed, precision, and reliability for both 
              industrial production and scientific research applications.
            </p>
          </div>
        </section>

        {/* Image Showcase Section */}
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          {images.slice(2).map((img, i) => (
            <div key={i} className="rounded-lg overflow-hidden transform transition-transform duration-500 hover:scale-105 shadow-xl">
              <img src={img} alt={`Novacam ${i + 3}`} className="w-full h-72 object-cover" />
            </div>
          ))}
        </section>

        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at: 
            <a href="mailto:rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
              rambomble@alphaq.co.in
            </a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default Product2;
